import { render, staticRenderFns } from "./UnitInformationVictory.vue?vue&type=template&id=6f17a038&scoped=true&lang=pug&"
import script from "./UnitInformationVictory.vue?vue&type=script&lang=ts&"
export * from "./UnitInformationVictory.vue?vue&type=script&lang=ts&"
import style0 from "./UnitInformationVictory.vue?vue&type=style&index=0&id=6f17a038&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f17a038",
  null
  
)

export default component.exports